import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "vds-drawer-header",
    templateUrl: "./drawer-header.component.html",
    styleUrl: "./drawer-header.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "vds-drawer-header"
    },
    standalone: true
})
export class DrawerHeaderComponent {}
